import React from 'react';
import socketio from 'socket.io-client';
import { socketURL } from '../config/keys';

// console.log("socketURL", socketURL);
export const socket = socketio.connect(socketURL);
export const SocketContext = React.createContext();
